<template>
    <v-card>
        <v-layout wrap>
            <v-flex xs12 sm6>
                <v-card-text>
                    <baby 
                        :weight="2 * weight / (max_weight + min_weight)"
                        :height="2 * height / (max_height + min_height)"
                        :gender="gender"
                        :color="gender === 'Boy' ? boyColor : girlColor"
                        @change="change"/>
                    <v-menu
                            v-model="picker"
                            :position-x="x"
                            :position-y="y"
                            absolute
                            :close-on-content-click="false"
                            offset-y>
                            <v-card>
                                    <Sketch 
                                        :value="gender === 'Boy' ? boyColor[item] : girlColor[item]"
                                        @input="updateColor" />
                            </v-card>
                        </v-menu>
                </v-card-text>
            </v-flex>
            <v-flex xs12 sm6>
                <v-card-text>
                    <v-card-actions>
                        <v-subheader>Gender</v-subheader>
                        <v-spacer />
                        <v-switch
                            :class="gender"
                            :label="gender"
                            false-value="Boy"
                            true-value="Girl"
                            color="pink"
                            v-model="gender"
                        ></v-switch>
                    </v-card-actions>
                    <v-card-actions>
                        <v-subheader>Weight (kg)</v-subheader>
                        <v-slider
                            v-model="weight"
                            :min="min_weight"
                            :max="max_weight"
                            always-dirty
                            step="100"
                            thumb-size="48"
                            thumb-label="always"
                        >
                        <template
                            slot="thumb-label"
                            slot-scope="props"
                            >
                            <span>
                                {{ (props.value) / 1000 }}kg
                            </span>
                            </template>
                        </v-slider>
                    </v-card-actions>
                    <v-card-actions>
                        <v-subheader>Height (cm)</v-subheader>
                        <v-slider
                            v-model="height"
                            :min="min_height"
                            :max="max_height"
                            thumb-size="48"
                            thumb-label="always"
                            always-dirty
                        >
                            <template
                                slot="thumb-label"
                                slot-scope="props"
                                >
                                <span>
                                    {{ (props.value) }}cm
                                </span>
                            </template>
                        </v-slider>
                    </v-card-actions>
                    <v-subheader>Birthday</v-subheader>
                    <v-card-actions>
                        <v-date-picker
                            v-model="date"
                            current
                            show-current="2018-09-13"
                            full-width
                            :landscape="$vuetify.breakpoint.mdAndUp"
                            class="mt-3"
                            ></v-date-picker>
                    </v-card-actions>
                </v-card-text>
            </v-flex>
        </v-layout>
        <v-card-actions>
            <v-btn round block :disabled="!date" color="primary" @click="$emit('save', baby)">
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import Baby from '@/components/baby/Baby'
import { Sketch, Material } from 'vue-color'

export default {
    data () {
        return {
            weight: 3500,
            min_weight: 2500,
            max_weight: 6000,
            min_height: 40,
            max_height: 60,
            height: 50,
            gender: "Girl",
            date: null,
            picker: false,
            x: 0,
            y: 0,
            item: 'skin',
            color: '#FFD6B3',
            boyColor: {
                skin: '#FFD6B3',
                arm:  '#00AA9A',
                wrist: '#009D93',
                body: '#00BEA5',
                circle1: '#B2C56D',
                circle2: '#FFC855',
                mouth: '#00BEA5',
                pacifier: '#007D82',
                eye: '#6E4141',
                hair: '#C3A587'
            },
            girlColor: {
                skin: '#FFD6B3',
                arm:  '#D25566',
                wrist: '#A5465A',
                body: '#FF6472',
                circle1: '#FF9663',
                circle2: '#FFC855',
                mouth: '#FF6472',
                pacifier: '#A5465A',
                eye: '#6E4141',
                hair: '#C3A587'
            }
        }
    },
    computed: {
        baby () {
            return {
                weight: this.weight,
                height: this.height,
                gender: this.gender,
                color: this.gender === 'Boy' ? this.boyColor : this.girlColor,
                date: new Date(this.date)
            }
        }
    },
    methods: {
        change({event, item, color}) {
            this.x = event.clientX
            this.y = event.clientY
            this.item = item
            this.color = this.gender === "Boy" ? this.boyColor[item] : this.girlColor[item]
            this.picker = true
            console.log(item)
        },
        updateColor({hex}) {
            if (this.gender === "Boy") {
                this.boyColor[this.item] = hex
            } else {
                this.girlColor[this.item] = hex
            }
        }
    },
    watch: {
        color(color) {
            if (!this.item || !color) {
                return
            }
            if (this.gender === "Boy") {
                this.boyColor[this.item] = color
            } else {
                this.girlColor[this.item] = color
            }
        }
    },
    components: {
        Sketch,
        Material,
        Baby
    }
}
</script>


<style>
    .Boy .v-input--switch__track {
        color: rgb(0, 190, 165) !important;
    }
    .Boy .v-input--switch__thumb {
        color: rgb(0, 170, 154) !important;
    }

</style>
